import React from "react";
import styles from "./styles.module.scss";
import { Token } from "app/utils/stripe";
import AnalyzeCheckout from "app/components/StripeForm/AnalyzeCheckout";
import { AnalyzePlanType } from "../PricingToggle";
import { Currency } from "app/utils/currency";

interface IProps {
  onDone?: (token?: Token, reprice?: boolean) => void;
  onCancel?: () => void;
  planCode?: AnalyzePlanType;
  couponCode?: string;
  currency?: Currency;
  purchase?: boolean;
  reprice?: boolean;
  // The trial paywall's buttons (see the Stripe form).
  ctaText?: string;
  showFreePlanButton?: boolean;
  freePlanText?: string;
}

const BillingInformation = ({
  onDone,
  planCode,
  couponCode,
  currency,
  purchase,
  reprice,
  ctaText,
  showFreePlanButton,
  freePlanText,
}: IProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.divider} />
      <AnalyzeCheckout
        onToken={onDone}
        planCode={planCode}
        couponCode={couponCode}
        currency={currency}
        purchase={purchase}
        reprice={reprice}
        ctaText={ctaText}
        showFreePlanButton={showFreePlanButton}
        freePlanText={freePlanText}
      />
    </div>
  );
};

export default BillingInformation;
